import React from 'react'

function Pendingpayment() {
    return (
        <>
          <div className="w-full h-auto p-4 sm:p-6 md:p-8">
  <div className="w-full bg-white rounded-xl">
    <div className="w-full">
      <h1 className="text-[20px] font-bold text-gray-800 py-4 px-6">Verify Payment History</h1>
    </div>
    <div className="w-full border-b border-[#c0bebe] border-dashed" />

    <div className="flex flex-wrap gap-4 px-6 py-4 items-center">
      <div className="flex items-center gap-2">
        <label className="text-[16px] font-medium text-[#555454]">Show</label>
        <select className="border border-[#c0bfbf] rounded-md w-[70px] h-[32px] px-2">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <span className="text-[16px] font-medium text-[#555454] pl-2">entries</span>
      </div>

      <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap sm:ml-auto">
        <label className="text-[16px] font-medium text-[#555454]">Search:</label>
        <input
          type="text"
          className="border border-[#c0bfbf] rounded-md h-[32px] px-3 w-full sm:w-[250px]"
          placeholder="Search..."
        />
      </div>
    </div>

    <div className="px-6 py-4">
      <div className="overflow-x-auto">
        <table className="min-w-full border border-dashed border-[#c0bebe]">
          <thead>
            <tr className="text-left text-sm font-semibold text-gray-700 whitespace-nowrap">
              <th className="border border-dashed border-[#c0bebe] px-4 py-2">S.N</th>
              <th className="border border-dashed border-[#c0bebe] px-4 py-2">Name</th>
              <th className="border border-dashed border-[#c0bebe] px-4 py-2">Phone</th>
              <th className="border border-dashed border-[#c0bebe] px-4 py-2">Amount</th>
              <th className="border border-dashed border-[#c0bebe] px-4 py-2">Exchange</th>
              <th className="border border-dashed border-[#c0bebe] px-4 py-2">Exchange User Id</th>
              <th className="border border-dashed border-[#c0bebe] px-4 py-2">Agent</th>
              <th className="border border-dashed border-[#c0bebe] px-4 py-2">Transaction Id</th>
              <th className="border border-dashed border-[#c0bebe] px-4 py-2">Transaction Status</th>
            </tr>
          </thead>
         <tbody>
  <tr className="bg-gray-100 text-sm text-gray-700 whitespace-nowrap">
    <td className="px-4 py-2">1</td>
    <td className="px-4 py-2">Rajnish</td>
    <td className="px-4 py-2">6973727813</td>
    <td className="px-4 py-2 text-green-600 font-semibold">+ 899</td>
    <td className="px-4 py-2">All Panel</td>
    <td className="px-4 py-2">-</td>
    <td className="px-4 py-2">No Admin</td>
    <td className="px-4 py-2">teest</td>
    <td className="px-4 py-2">
      <span className="text-green-600 font-medium">credit</span>{" "}
      / <span className="text-red-500 font-medium">pending</span>
    </td>
  </tr>
</tbody>

        </table>
      </div>

      <div className="w-full flex flex-col sm:flex-row justify-between items-center gap-4 py-4">
        <span className="text-[16px] font-medium text-[#555454] text-center sm:text-left">
          Showing 0 to 0 of 0 entries
        </span>
        <div>
          <button
            className="px-4 py-1 border border-[#c0bebe] text-gray-400 bg-gray-100 cursor-not-allowed rounded-l-md"
            disabled
          >
            Previous
          </button>
          <button
            className="px-4 py-1 border border-[#c0bebe] text-gray-400 bg-gray-100 cursor-not-allowed rounded-r-md"
            disabled
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
        </>
    )
}

export default Pendingpayment
